<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="grid"
        config-module="101321"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;padding-left: 5px;">
        <el-form label-width="90px" label-position="left">
          <el-form-item :label="$t('CargoMsg.Cargo_BusinessType')">
            <cargo-advance-select
              no="jobType"
              filterable
              :select-type="selectTypeNames.basic_data_IncoTerm"
              callback-method-type="value"
              :default-value="editDialog.form.jobType"
              :callback-params="{key:'jobType'}"
              @parentCallBack="setEditDialogValue"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_PaymentPeriodRange')">
            <el-input-number v-model="editDialog.form.accountPeriodBegin" no="accountPeriodBegin" :min="0" :max="9999999" :precision="0" controls-position="right" style="width: 103px" />
            <span>{{ $t('CargoMsg.Cargo_To') }}</span>
            <el-input-number v-model="editDialog.form.accountPeriodEnd" no="accountPeriodEnd" :min="0" :max="9999999" :precision="0" controls-position="right" style="width: 103px;" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CommissionPercentage')">
            <el-input-number v-model="editDialog.form.percentage" no="percentage" :min="0" :max="9999999" :precision="0" controls-position="right" style="width: 205px" />
            <span>%</span>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Post')">
            <el-select v-model="editDialog.form.role" no="role" style="width: 220px">
              <el-option v-for="(item,index) in ruleRoles" :key="index" :label="item.chineseName||' '" :value="item.code" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCommissionRuleList, saveCommissionRule, delCommissionRule } from '@/api/basicData/commissionRule'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getLoading } from '@/utils/utilBaseElement'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'CommissionRule',
  components: { cargoAdvanceSelect },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessType'),
          field: 'jobType',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Post'),
          field: 'role',
          width: 200,
          valueFormatter: params => this.roleLabelFunc(params.value)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PaymentPeriodRange'),
          field: '',
          width: 200,
          valueFormatter: params => params.data.accountPeriodBegin + '-' + params.data.accountPeriodEnd
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CommissionPercentage'),
          field: 'percentage',
          width: 200,
          valueFormatter: params => params.value + '%'
        }
      ],
      rowData: null,
      ruleRoles: [],
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          jobType: '',
          role: '',
          dateDatum: 0,
          accountPeriodBegin: 0,
          accountPeriodEnd: 0,
          percentage: 0.0
        }
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  created() {
    this.ruleRoles = CheckRuleConstants.COMMISSION_RULE_ROLES
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    setEditDialogValue(obj) {
      this.editDialog.form[obj.key] = obj.value
    },
    toQuery() {
      const self = this
      const loading = getLoading()
      getCommissionRuleList(self.filter).then(res => {
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          jobType: ''
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_CommissionRules')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('CargoMsg.Cargo_CommissionRules')
      }
      this.editDialog.visible = true
    },
    save() {
      const self = this
      const form = self.editDialog.form
      form.dateDatum = 0
      if (!form.accountPeriodBegin && !form.accountPeriodEnd) {
        this.$message.warning(this.$t('CargoMsg.Cargo_AccountingPeriodRange'))
        return
      }
      if (!form.accountPeriodBegin) {
        form.accountPeriodBegin = 0
      }
      if (!form.accountPeriodEnd) {
        form.accountPeriodEnd = 0
      }
      if (!form.percentage) {
        form.percentage = 0.0
      }
      saveCommissionRule(form).then(res => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        self.toQuery()
        self.editDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.editDialog.visible = false
      })
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        delCommissionRule(rows[0].uuid).then(res => {
          self.filter.pageNum = 1
          self.toQuery()
          self.$message.success(self.$t('common.tips.deleteSuccess'))
        })
      }).catch(() => { })
    },
    roleLabelFunc(value) {
      let result = ''
      const role = SystemConstants.getCommonState(value, CheckRuleConstants.COMMISSION_RULE_ROLES)
      if (role) {
        if (this.$i18n.locale === 'zh') {
          result = role.chineseName
        } else {
          result = role.englishName
        }
      }
      return result
    }
  }
}
</script>

<style>
</style>
